export class CustomAutomationInfo {
  supported_filters: {[filter: string]: string[]};

  constructor(v: Partial<CustomAutomationInfo>) {
    this.supported_filters = v.supported_filters || {};
  }
}
